var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "pending_actions"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26122_232734",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.599609,
    width: 24,
    height: 24,
    fill: "#E88614"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26122_232734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pending_actions_2",
    d: "M17 22.5996C15.6167 22.5996 14.4375 22.1121 13.4625 21.1371C12.4875 20.1621 12 18.9829 12 17.5996C12 16.2163 12.4875 15.0371 13.4625 14.0621C14.4375 13.0871 15.6167 12.5996 17 12.5996C18.3833 12.5996 19.5625 13.0871 20.5375 14.0621C21.5125 15.0371 22 16.2163 22 17.5996C22 18.9829 21.5125 20.1621 20.5375 21.1371C19.5625 22.1121 18.3833 22.5996 17 22.5996ZM18.675 19.9746L19.375 19.2746L17.5 17.3996V14.5996H16.5V17.7996L18.675 19.9746ZM5 21.5996C4.45 21.5996 3.97917 21.4038 3.5875 21.0121C3.19583 20.6204 3 20.1496 3 19.5996V5.59961C3 5.04961 3.19583 4.57878 3.5875 4.18711C3.97917 3.79544 4.45 3.59961 5 3.59961H9.175C9.35833 3.01628 9.71667 2.53711 10.25 2.16211C10.7833 1.78711 11.3667 1.59961 12 1.59961C12.6667 1.59961 13.2625 1.78711 13.7875 2.16211C14.3125 2.53711 14.6667 3.01628 14.85 3.59961H19C19.55 3.59961 20.0208 3.79544 20.4125 4.18711C20.8042 4.57878 21 5.04961 21 5.59961V11.8496C20.7 11.6329 20.3833 11.4496 20.05 11.2996C19.7167 11.1496 19.3667 11.0163 19 10.8996V5.59961H17V8.59961H7V5.59961H5V19.5996H10.3C10.4167 19.9663 10.55 20.3163 10.7 20.6496C10.85 20.9829 11.0333 21.2996 11.25 21.5996H5ZM12 5.59961C12.2833 5.59961 12.5208 5.50378 12.7125 5.31211C12.9042 5.12044 13 4.88294 13 4.59961C13 4.31628 12.9042 4.07878 12.7125 3.88711C12.5208 3.69544 12.2833 3.59961 12 3.59961C11.7167 3.59961 11.4792 3.69544 11.2875 3.88711C11.0958 4.07878 11 4.31628 11 4.59961C11 4.88294 11.0958 5.12044 11.2875 5.31211C11.4792 5.50378 11.7167 5.59961 12 5.59961Z",
    fill: "#E88614"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.f5f7177bf8ab34d7c7822f49cc8df0fc.svg";
export { ForwardRef as ReactComponent };